import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import {isLoading} from "Modules/Loading"
import { post } from 'axios'

const initialState = Immutable.Map({}).set('Search', new Immutable.List([])).set('Response', new Immutable.Map({})).set('Get', new Immutable.Map({}))

/* Types */
export const ACTION_SEARCH_ACTOR = 'ACTION_SEARCH_ACTOR'

export const ACTION_GET_ACTOR = 'ACTION_GET_ACTOR'

export const ACTION_DELETE_ACTOR = 'ACTION_DELETE_ACTOR'

export const ACTION_UPDATE_ACTOR = 'ACTION_UPDATE_ACTOR'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {

		case ACTION_SEARCH_ACTOR:
			return state.set('Search', new Immutable.List(action.Obj))
		case ACTION_GET_ACTOR:
			return state.set('Get', new Immutable.Map(action.Obj))
		case ACTION_DELETE_ACTOR:
			return state.set('Response', new Immutable.Map(action.Obj))
		case ACTION_UPDATE_ACTOR:
			return state.set('Response', new Immutable.Map(action.Obj))
		default:
			return state
	}
}

/* Action Creators */

export const addActor = (form) => {

	let contactos = Utils.getListPropsOmit(form.contactos, ['id', 'tmp', 'name'])

	let temp = {
		"areaEspecialidad": form.expAreas,
		"comentarios": form.commentaries,
		contactos,
		"createdBy": sessionStorage.uid,
		"createdDate": new Date().toISOString(),
		"deleted": form.status,
		"domicilio": {
			"calle": form.street,
			"deleted": false,
			"entreCalle1": form.bstreet1,
			"entreCalle2": form.bstreet2,
			"idCiudad": form.city,
			"idCodigoPostal": form.cp,
			"idColonia": form.colony,
			"idEstado": form.state,
			"idMunicipioDelegacion": form.town,
			"numeroExterior": form.numext,
			"numeroInterior": form.numint,
			"referencia": form.reference,
			"tipoDomicilio": "Fiscal"
		},
		"email": form.mail,
		"estatus":  form.status == 2 ? 'I' : 'A',
		"experiencia": form.experience,
		"extension": form.ext,
		"lastModifiedBy": null,
		"lastModifiedDate": null,
		"paginaWeb": form.website,
		"razonSocial": form.razonSocial,
		"siglas": form.acronym,
		"telefono": form.telefono
	}

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/newActor',
			method: "POST",
			data: {...temp},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_UPDATE_ACTOR, Obj: {...form, id:response.data.id} })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}

}

export const searchActor = (form) => {

	Utils.clearNullAndEmpty(form)

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: Object.keys(form).length == 0 ? 'api/getAllActor': 'api/searchActor',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_SEARCH_ACTOR, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getActor = (id) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getActor',
			method: "POST",
			data: { id },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			let data = response.data

			let contactos = []
			let documentosOtroActor = []

			if (data.contactos !== null) {
				contactos = data.contactos.map((c) => {
					return {...c, name: `${c.nombre} ${c.apellidoPaterno} ${c.apellidoMaterno}`}
				})
				contactos = contactos.filter((c) => !c.deleted)
			}

			if (data.documentosOtroActor) {
				documentosOtroActor = data.documentosOtroActor.map((d) => {
					return {
						id: d.idDocumento,
						nombre: decodeURI(d.nombre),
						descripcion: d.descripcion,
						documento: {
							idDocumento: d.dropboxId
						}
					}
				})
			}

			let temp = {
				id: data.id,
				razonSocial: data.razonSocial,
				acronym: data.siglas,
				status: !data.deleted ? 1 : 2,
				telefono: data.telefono,
				ext: data.extension,
				mail: data.email,
				website: data.paginaWeb,
				cp: data.domicilio.idCodigoPostal,
				state: data.domicilio.idEstado,
				town: data.domicilio.idMunicipioDelegacion,
				city: data.domicilio.idCiudad,
				colony: data.domicilio.idColonia,
				street: data.domicilio.calle,
				numext: data.domicilio.numeroExterior,
				numint: data.domicilio.numeroInterior,
				bstreet1: data.domicilio.entreCalle1,
				bstreet2: data.domicilio.entreCalle2,
				reference: data.domicilio.referencia,
				commentaries: data.comentarios,
				experience: data.experiencia,
				expAreas: data.areaEspecialidad,
				contactos: contactos,
				documentosOtroActor: documentosOtroActor
			}

			dispatch({ type: ACTION_GET_ACTOR, Obj: temp })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const updateActor = (form) => {
	let data = Object.assign({}, form)
	data.contactos = Utils.getListPropsOmit(data.contactos, ['id', 'tmp','name'])
	data.contactos = Utils.unionArray(data.contactos, data.contactosRemove)

	let contactos = data.contactos.map((c) => {
		delete c.name
		return {...c }
	})

	let temp = {
		"areaEspecialidad": form.expAreas,
		"comentarios": form.commentaries,
		contactos,
		"deleted": form.status,
		"domicilio": {
			"calle": form.street,
			"deleted": false,
			"entreCalle1": form.bstreet1,
			"entreCalle2": form.bstreet2,
			"idCiudad": form.city,
			"idCodigoPostal": form.cp,
			"idColonia": form.colony,
			"idEstado": form.state,
			"idMunicipioDelegacion": form.town,
			"numeroExterior": form.numext,
			"numeroInterior": form.numint,
			"referencia": form.reference,
		},
		"email": form.mail,
		"id": form.id,
		"estatus": form.status == 2 ? 'I' : 'A',
		"experiencia": form.experience,
		"extension": form.ext,
		"lastModifiedBy": sessionStorage.uid,
		"lastModifiedDate": new Date().toISOString(),
		"paginaWeb": form.website,
		"razonSocial": form.razonSocial,
		"siglas": form.acronym,
		"telefono": form.telefono
	}

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/setActor',
			method: "POST",
			data: {...temp},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const updateActorDoc = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/setActorDoc',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}


export const uploadDocumentActor = (form) => {

	const headers = {
		"Content-Type": "multipart/form-data",
		"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid
	}

	if (localStorage.type == 'Donataria') {
		headers.idDonataria = localStorage.idDonataria || ''
	}

	return (dispatch) => {

		dispatch(isLoading(true))

		return post('/api/uploadDocumentActor', form, {headers})
			.then((response) => {
				dispatch(isLoading(false))

				return response.data;
			}).catch((error) => {
				dispatch(isLoading(false))
				dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
				throw error;
			})
	}
}


export const deleteDocumentActor = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/deleteDocumentActor',
			method: "POST",
			data: { ...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))

			//dispatch({ type: ACTION_GET_ACTOR, Obj: temp })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const clearActor = () => {
	return (dispatch) => {
		dispatch({ type: ACTION_GET_ACTOR, Obj: {} })
		dispatch({ type: ACTION_SEARCH_ACTOR, Obj: []})
	}
}



// WEBPACK FOOTER //
// ./src/modules/Configurations/Actor/index.js